import React, { useEffect, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import InsightHighlightsGridItem  from '../InsightHighlights/InsightHighlightsGridItem'
import InsightHighlightsAction from '../../../redux/actions/insightHighlights/InsightHighlightsAction'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ToolTipWrapper from '../Tooltip/ToolTipWrapper'

import '../../../css/InsightHighlights.scss'
import Icon from '../icons/Icons'
import { IconLibrary } from  '@/interfaces/IconLibrary'
import { IRootState } from 'redux/reducers'

const InsightHighlights = () => {

    const dispatch = useDispatch()
    const highlights = useSelector((state: IRootState)  => state.insightHighlights.highlights)

    useEffect(() => {
        dispatch(InsightHighlightsAction.requestInsightHightlights())
    }, [dispatch]);
    
    if (!highlights) {
        return <></>
    }

    return(
        <section className={`${highlights !== null ? 'fade-in-shown' : 'fade-in-hidden'} thrive-panel thrive-small-panel-right sml-highlights-header`}>

            <h1>Highlights this week</h1>

            <ToolTipWrapper id="highlight-tooltip" className="tracks-side-tooltip">
                <ReactTooltip id="highlight-tooltip" place="top" className='thrive-tooltip' delayHide={1000}>
                    <span>Your organisation insights for this week</span>
                </ReactTooltip>
            </ToolTipWrapper>

            <div className="sml-highlights-grid">
                {highlights &&
                    <Fragment>
                        <InsightHighlightsGridItem name="User Logins" icon="user.svg" value={highlights.userLogins} />
                        <InsightHighlightsGridItem name="Content Views" icon="content_views.svg" value={highlights.contentViews} />
                        <InsightHighlightsGridItem name="Likes" icon={<Icon iconName={IconLibrary.LIKE_ACTIVE} color="#106DE0" sizeInPx='16'/>} value={highlights.likes} />
                        <InsightHighlightsGridItem name="Comments" icon="comments.svg" value={highlights.comments} />
                        <InsightHighlightsGridItem name="UGC Posts" icon="ugc.svg" value={highlights.ugcPosts} />
                        <InsightHighlightsGridItem name="People Thanked" icon="thanked.svg" value={highlights.peopleThanked} />
                    </Fragment>
                }           
            </div>
            
            <a href="/admin/Insights">View insights dashboard</a>
        </section>
    )
}

export default InsightHighlights